export default __webpack_public_path__ + "static/media/margretlogo.94342bb8.png";